/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace whitespace variable-name */

import { Injectable  }           from '@angular/core';
import { HttpClient }           from '@angular/common/http';
import { HttpHeaders }           from '@angular/common/http';
import { HttpParams  }           from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { UUIDService }           from '@/services/uuid.service';

import {
  Blob,
  BlobType
}                                from '../models/blob';
import { User       }            from '../models/user';


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class KPIService
 *
 * @brief adaptor to work with remote KPI service
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class KPIService {

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    public  uuid: UUIDService
  ) {

  }

  /** fetch any headers we need to send along with our request */
  headers(): HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    return new HttpHeaders().set('Authorization', `Bearer ${user.token}`);
  }

  /** fetch a download from the remote line simulator */
  public kpi(input: string, output: string, kpi: string) {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    const params  = new HttpParams().
      set('input',  input).
      set('output', output).
      set('kpi',    kpi);

    /* pass back this hits */

    return this.http.get(`/backend/kpi`, {
      headers,
      params
    });
  }

  /** fetch a download from the remote line simulator */
  public kpix(input: string, output: string, kpix: string) {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    const params  = new HttpParams().
    set('input',  input).
    set('output', output).
    set('kpix',   kpix);

    /* pass back this hits */

    return this.http.get(`/backend/kpix`, {
      headers,
      params
    });
  }

}
